import { createFileRoute } from "@tanstack/react-router";
import ProcureTakeoffsLayout from "lib/components/procure/layout/ProcureTakeoffsLayout";
import ProcureTakeoffsView from "lib/components/procure/ProcureTakeoffsView";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../../../components/withAuthentication";

function ProcureTakeoffsPage() {
  const { content, nav, sidebar } = ProcureTakeoffsView();

  return (
    <>
      <Head>
        <title>{getPageTitle("Estimate: Takeoffs")}</title>
      </Head>
      <ProcureTakeoffsLayout content={content} nav={nav} sidebar={sidebar} />
    </>
  );
}

export const Route = createFileRoute("/builders/$builder_id/estimate/")({
  component: withAuthentication(ProcureTakeoffsPage, { products: ["procure"] }),
});
